import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { seoTemplateCollectionPageDetailLoad } from "store/models/seoTemplateCollectionPage";
import { DetailLoadComponent } from 'components/common';


const SeoTemplateCollectionPageValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={seoTemplateCollectionPageDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(item && item.type, id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.tpl_path) || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.seoTemplateCollectionPage,
});

export default connect(mapState)(SeoTemplateCollectionPageValue);
